import { render, staticRenderFns } from "./OtherRelationshipEditor.vue?vue&type=template&id=af99e738&scoped=true"
import script from "./OtherRelationshipEditor.vue?vue&type=script&lang=js"
export * from "./OtherRelationshipEditor.vue?vue&type=script&lang=js"
import style0 from "./OtherRelationshipEditor.vue?vue&type=style&index=0&id=af99e738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af99e738",
  null
  
)

export default component.exports